export const RIGHT = 'right';
export const LEFT = 'left';
export const DOWN = 'down';
export const UP = 'up';
